import React from 'react';

const AdminTrigger: React.FC = () => {
  // This component doesn't use useAuth, so it's safe to render outside the provider
  return null; // Placeholder component
};

export default AdminTrigger;
